<template>
  <y-wrapper @back="handleBack">
    <template slot="nav">
      <div class="nav-wrap">
        <div
          class="left"
          v-if="transferItem && transferItem.transfer_item_name"
        >
          {{ transferItem.transfer_item_name || "教练员注册申请详情" }}
        </div>
        <div class="left" v-else>教练员注册申请详情</div>
        <div class="right"></div>
      </div>
    </template>
    <template slot="main">
      <div class="main-content">
        <template v-if="isLoading">
          <yioks-loading></yioks-loading>
        </template>
        <div v-else class="page-scroll-wrapper">
          <vue-scroll :ops="ops">
            <div class="content-wrap">
              <div class="yioks-flex-box">
                <div class="yioks-flex-item half">
                  <div class="yioks-card">
                    <div class="yioks-card-title" >
                      基本信息
                    </div>
                    <div class="yioks-card-content">
                      <div class="yioksf-flex-box column wrapper">
                        <div class="yioks-flex-item line">
                          <span class="mr10">状态：</span>
                          <span class="content"
                            >{{
                              transferItem.transfer_item_status | alterStatus
                            }}
                          </span>
                        </div>
                        <div class="yioks-flex-item line" v-show="transferItem.coach_submit_start && transferItem.coach_submit_end">
                          <span class="mr10">教练员注册申请窗口期：</span>
                          <span class="content"
                            >{{
                              transferItem.coach_submit_start | time(false)
                            }}
                            至{{ transferItem.coach_submit_end | time(false) }}
                          </span>
                        </div>
                        <div class="yioks-flex-item line" v-show="transferItem.enter_org_audit_end">
                          <span class="mr10">转入协会审核截止日期：</span>
                          <span class="content"
                            >{{
                              transferItem.enter_org_audit_end | time(false)
                            }}
                          </span>
                        </div>
                        <div class="yioks-flex-item line" v-show="transferItem.leave_org_audit_end">
                          <span class="mr10">转出协会审核截止日期：</span>
                          <span class="content"
                            >{{
                              transferItem.leave_org_audit_end | time(false)
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="yioks-flex-item half action-btn-wrapper">
                
                </div>
              </div>

              <div class="yioks-flex-box">
                <div class="yioks-flex-item">
                  <div class="yioks-card">
                    <div class="yioks-card-title" >
                      注册变更联系人
                    </div>
                    <div
                      class="yioks-card-content linkman-wrapper"
                      v-if="transferLinkMan.length"
                    >
                      <div class="yioks-flex-box tr">
                        <div class="yioks-flex-item th">姓名</div>
                        <div class="yioks-flex-item th">联系方式</div>
                        <div class="yioks-flex-item th">邮箱</div>
                        <div class="yioks-flex-item th work">单位</div>
                      </div>
                      <div
                        class="yioks-flex-box tr"
                        v-for="(item, index) in transferLinkMan"
                        :key="index"
                      >
                        <div class="yioks-flex-item td">
                          {{ item.name || "--" }}
                        </div>
                        <div class="yioks-flex-item td">
                          {{ item.mobile_phone || "--" }}
                        </div>
                        <div class="yioks-flex-item td">
                          {{ item.email || "--" }}
                        </div>
                        <div class="yioks-flex-item td work">
                          {{ item.work || "--" }}
                        </div>
                      </div>
                    </div>
                    <div class="yioks-card-content" v-else>
                      <yioks-empty h="150px"></yioks-empty>
                    </div>
                  </div>
                </div>
              </div>
              <div class="yioks-flex-box">
                <div class="yioks-flex-item">
                  <div class="yioks-card">
                    <div class="yioks-card-title" >
                      说明
                    </div>
                    <div class="yioks-card-content">
                      <div
                        v-if="transferItem.content"
                        class="text-wrapper"
                        v-html="transferItem.content"
                      ></div>
                      <div v-else class="text-wrapper">--</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="yioks-flex-box">
                <div class="yioks-flex-item">
                  <div class="yioks-card">
                    <div class="yioks-card-title" >
                      附件
                    </div>
                    <div class="yioks-card-content">
                      <template v-if="transferDocument.length">
                        <div
                          class="line"
                          v-for="(item, index) in transferDocument"
                          :key="index"
                        >
                          <span class="mr10">附件{{ index + 1 }}：</span>
                          <a
                            :data-href="item.document_address"
                            :href="item.document_address"
                            :download="item.document_title"
                          >
                            <span class="suc link">{{
                              item.document_title
                            }}</span>
                          </a>
                        </div>
                      </template>
                      <template v-else>
                        <yioks-empty h="150px"></yioks-empty>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
        <template v-if="isShowAlterView">
          <alteration-view
            :isShowAlterView.sync="isShowAlterView"
            :transfer_item_uuid="transfer_item_uuid"
          ></alteration-view>
        </template>
      </div>
    </template>
  </y-wrapper>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import { getTransferItemDetails } from "@/api/system_manager/api";
import { alterStatus } from "@/assets/js/yioksFilters";
import { getAlterationStatus, getDetaultInfoForAlteration } from "@/api/training_student/api";
export default {
  components: {
    "v-icon": () => import("vue-awesome/components/Icon"),
    "yioks-empty": () => import("@/components/Tips/Empty"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "yioks-paging": () => import("@/components/Pagination/Page"),
    "alteration-view": () => import("@/components/alteration/AlterationView"),
  },

  data() {
    return {
      ops: ops(),
      transferDocument: [],
      transferLinkMan: [],
      transferItem: {},
      is_can_sign: false,
      can_sign_msg: '',
      alterationStatus: '',
      isLoading: false,
      isShowAlterView: false,
      viewInfo: {},
      recordReport: [],
    };
  },
  filters: {
    alterStatus,

    isNeeded(val) {
      if (val == 0 || val == "0") {
        return "否";
      } else if (val == 1 || val == "1") {
        return "是(必传)";
      } else if (val == 2 || val == "2") {
        return "是(非必传)";
      } else {
        return "--";
      }
    },

    alterFilter(val) {
      if(val === 'Edit') {
        return true
      } else {
        return false
      }
    }
  },

  computed: {
    transfer_item_uuid() {
      const { transfer_item_uuid } = this.$route.query;
      return transfer_item_uuid;
    },
    backUrl() {
      const { backUrl } = this.$route.query;
      return backUrl;
    }
  },

  created() {
    this.loadAlterationDetails();
    this.loadAlterationStatus();
  },

  methods: {
    handleBack() {
      if(this.backUrl) {
        this.$router.push({
          path: this.backUrl
        })
      } else {
        this.$router.push("/");
      }
    },

    loadAlterationDetails() {
      this.isLoading = true;
      const paramsData = {
        transfer_item_uuid: this.transfer_item_uuid,
      };
      getTransferItemDetails(paramsData)
        .then(({ data }) => {
          this.isLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { can_sign_msg, is_can_sign, transferItem, transferDocument, transferLinkMan } =
            data.result;
          this.transferItem = transferItem;
          this.transferDocument = transferDocument;
          this.transferLinkMan = transferLinkMan;
          if(can_sign_msg) {
            this.can_sign_msg = can_sign_msg;
          } else {
            this.can_sign_msg = '';
          }
          this.is_can_sign = is_can_sign;
        })
        .catch((err) => {
          this.isLoading = false;
          console.error(err);
        });
    },

    handleSign(isEdit) {
      if(!this.is_can_sign) {
        if(this.can_sign_msg) this.$message.error(this.can_sign_msg)
        return
      }
      const { transfer_item_uuid } = this.transferItem;
      if(transfer_item_uuid) {
        this.$router.push({
          path: 'alter_avi_upload',
          query: {
            transfer_item_uuid: transfer_item_uuid,
            isEdit: isEdit ? '1' : '0'
          }
        })
      }
    },
    
    loadAlterationStatus() {
      // debugger
      const queryData = {
        transfer_item_uuid: this.transfer_item_uuid
      }
      getAlterationStatus(queryData).then(({data}) => {
        if(data.status !== 0) {
          this.$message.error(data.msg)
          return
        }
        const { record:{ status } } = data.result
        this.alterationStatus = status;
      })
      .catch(err => {
        console.error('err', err)
      })
    },

    handleView() {
      // console.log('handleView', '')
      // const queryData = {
      //   transfer_item_uuid: this.transfer_item_uuid,
      // };
      // getDetaultInfoForAlteration(queryData)
      //   .then(({data}) => {
      //     console.log('data', data)
      //     const { recordReport, transferRecord } = data.result;
      //     this.recordReport = recordReport;
      //     this.viewInfo = transferRecord;
      //     this.isShowAlterView = true;
      //   })
      //   .catch(err => {
      //     console.error('err', err)
      //   })
      this.isShowAlterView = true;
    },

    alterationCloseBefore() {
      this.isShowAlterView = false;
    },


  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/yioksCommon'
.nav-wrap
  flex 1
  box-sizing border-box
  padding 0 30px 0 0
  display flex
  justify-content space-between
  align-items center
  font-size $font_size_big
  .right
    font-size $font_size_big
    .btn
      padding 5px 15px
      cursor pointer
      user-select none
      &.active
        background-color $color_suc
      &+.btn
        margin-left 10px
.main-content
  flex 1 1 auto
  padding-top 25px
  box-sizing border-box
  width 100%
  background-color $block_bg_color_base
  .search-wrap
    display flex
    justify-content space-between
    align-items center
    height 40px
    margin 0 40px
    .left-search
      height 100%
      .select
        width 155px
        height 100%
        padding 0 15px
        font-size $font_size_medium
        color $color_black
        outline none
    .right-search
      height 100%
      .input-wrap
        width 290px
        height 100%
        display flex
        justify-content space-between
        align-items center
        position relative
        input
          width 200px
          height 100%
          padding 0 20px
          font-size $font_size_medium
          color $color_black
        .close
          position absolute
          right 100px
          top 10px
          color $color_info
          cursor pointer
    .searchBtn
      width 90px
      height 100%
      display flex
      justify-content center
      align-items center
      font-size 20px
      background-color $color_suc
      cursor pointer
      user-select none
.wrapper
  .line
    min-height 49px
    display flex
    align-items center
    font-size $font_size_medium
    .label
      width 190px
      text-align left
      margin-right 10px
.action-btn-wrapper
  box-sizing border-box
  margin-top 38px
  padding-right 20px
  display flex
  justify-content flex-end
  align-items flex-start
  .edit-btn
    display flex
    align-items center
    justify-content center
    padding 7px 18px
    width 110px
    margin 5px 10px
    color #fff
    cursor: pointer
    user-select: none
    &.suc
      background-color $color_suc
    &.err
      background-color $color_unusual
    &.deny
      background-color #ccc
      cursor not-allowed
.linkman-wrapper
  border 1px solid #ccc
  margin 10px
  padding 0px !important
  .tr
    min-height 49px
    &:not(:last-child)
      border-bottom 1px solid #ccc
    .th, .td
      display flex
      align-items center
      justify-content center
      &:not(:last-child)
        border-right 1px solid #ccc
      &.work
        flex-basis auto
        width 180px
.page-scroll-wrapper
  height 580px
  .content-wrap
    margin 0 25px
.suc
  color $color_suc
.link
  cursor pointer
  user-select none

.title-dialog
  font-size 1.6em
  font-weight 600
  border-bottom 2px solid #ccc
  padding-bottom 10px
  color #666
.view-content
  padding  10px  10px
  .card-item
    margin-bottom 20px
    .card-title
      font-size 1.3em
      font-weight 600
      color #666
      border-bottom 1px solid #ccc
      padding-bottom: 10px
    .card-content
      padding 5px 20px
      .line
        min-height 49px
        display flex
        align-items center
        font-size $font_size_medium

/deep/.view-box
  .el-dialog__body
    padding 5px 20px 20px
</style>
